import { useCallback, useState } from "react";

type Params = {
  steps: number;
  initialStep?: number;
};

export function useStepper({ steps, initialStep = 0 }: Params) {
  const [activeStep, setActiveStep] = useState(initialStep);

  const canGoNext = activeStep < steps - 1;
  const canGoBack = activeStep > 0;

  const handleNext = useCallback(() => {
    setActiveStep((prev) => (prev < steps - 1 ? prev + 1 : prev));
  }, [steps]);

  const handleBack = useCallback(() => {
    setActiveStep((prev) => (prev > 0 ? prev - 1 : prev));
  }, []);

  return {
    activeStep,
    canGoNext,
    canGoBack,
    handleNext,
    handleBack,
    setStep: setActiveStep,
  };
}
